import { createGlobalStyle, ThemeProps } from 'styled-components'
import { BaseTokenType } from '@awaze/design-system.design-tokens'

export const GlobalStyleExtended = createGlobalStyle`
  html,
  body {
background-color: ${({ theme }: ThemeProps<BaseTokenType>) =>
  theme.ColorThemeBackgroundPage};
  }
`
